import { atom } from 'jotai'

export const exitFullScreenAtom = atom<boolean>(false)
